// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';

const TranslatedTextArea = ({intl, placeholder, ...props}) => {

    const {formatMessage} = intl;
    const translatedText = formatMessage({id: placeholder});

    return (
        <textarea
            {...props}
            placeholder={translatedText}
        />
    );

};

TranslatedTextArea.displayName = 'TranslatedTextArea';
TranslatedTextArea.propTypes = {
    intl: intlShape.isRequired,
    placeholder: PropTypes.string
};

export default injectIntl(TranslatedTextArea);



// WEBPACK FOOTER //
// ./src/shared/components/translated-text-area.js